import { useToast } from "@chakra-ui/react";
import { db, functions } from "connections/firebase";
import {
  updateDoc,
  QueryDocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
  DocumentData,
  collection,
  doc,
  FirestoreDataConverter,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { IUser } from "interfaces/user";
import { useEffect, useState } from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";

const userConverter: FirestoreDataConverter<IUser> = {
  toFirestore(user: WithFieldValue<IUser>): DocumentData {
    return user;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): IUser {
    const data = snapshot.data(options);
    return {
      name: data.name,
      email: data.email,
      id: snapshot.id,
      houseId: data.houseId,
      status: data.status,
      ttlock: {
        ttlockPassword: data.ttlock.ttlockPassword,
        username: data.ttlock.username,
      },
    };
  },
};

const collection_name = "users";

export default function useUser() {
  const toast = useToast();
  const deleteUserFunction = httpsCallable(functions, "deleteUser");
  const [data, loading, error] = useCollectionData(
    collection(db, collection_name).withConverter(userConverter),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );

  const [loadingAction, setLoadingAction] = useState<null | string>(null);

  const updateStatusUser = async (id: string, status: boolean) => {
    setLoadingAction(id);
    await updateDoc(doc(db, collection_name, id), {
      status,
    });
    setLoadingAction(null);
  };

  const deleteUser = async (id: string) => {
    try {
      setLoadingAction("new");
      await deleteUserFunction({ id });
    } catch (error) {
      setLoadingAction(null);
      return Promise.reject(error);
    }

    setLoadingAction(null);
  };

  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error, toast]);

  return {
    data,
    loading,
    updateStatusUser,
    deleteUser,
    loadingAction,
  };
}
